import Axios from 'axios';

const requests = [];
const { CancelToken } = Axios;
let api = Axios;

const cancelable = (config = {}) => {
  let cancel;
  const cancelToken = new CancelToken((c) => {
    cancel = c;
    requests.push(cancel);
  });
  return { ...config, cancelToken };
};

const getEnrollment = async () => {
  const response = await api.get('/ev-charging/enrollment', cancelable());
  return response.data;
};

const createSetupIntent = async () => {
  const response = await api.post(
    '/ev-charging/enrollment/setup-intent',
    {},
    cancelable(),
  );
  return response.data;
};

const completeEnrollment = async (paymentMethodId) => {
  const response = await api.post(
    '/ev-charging/enrollment/complete',
    { payment_method_id: paymentMethodId },
    cancelable(),
  );
  return response.data;
};

const cancelEnrollment = async () => {
  const response = await api.delete('/ev-charging/enrollment', cancelable());
  return response.data;
};

const acceptTos = async () => {
  const response = await api.post('/ev-charging/tos/accept', {}, cancelable());
  return response.data;
};

const getActiveSession = async () => {
  const response = await api.get('/ev-charging/sessions/active', cancelable());
  return response.data;
};

const getWallet = async () => {
  const response = await api.get('/ev-charging/wallet', cancelable());
  return response.data;
};

const getStatement = async (period) => {
  const config = period ? { params: { period } } : {};
  const response = await api.get('/ev-charging/statements', cancelable(config));
  return response.data;
};

const init = (axiosApi) => {
  api = axiosApi;
};

const EVChargingService = {
  init,
  getEnrollment,
  createSetupIntent,
  completeEnrollment,
  cancelEnrollment,
  acceptTos,
  getActiveSession,
  getWallet,
  getStatement,
};

export default EVChargingService;
